import React, { Component } from "react";
import { Link } from "react-router-dom";
export default class LoginController extends Component {

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      page: ""
    };
  }

  render() {
    if (this.state.redirect) {
      return <Link to="/" />;
    }
    return (
      <div />
    );
  }
}